import { render, staticRenderFns } from "./Enroll.vue?vue&type=template&id=4854a388"
import script from "./Enroll.vue?vue&type=script&lang=js"
export * from "./Enroll.vue?vue&type=script&lang=js"
import style0 from "./Enroll.vue?vue&type=style&index=0&id=4854a388&prod&scope=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports